<template>
  <div>
    <main-layout>
      <v-tabs v-model="advancedTab" slider-color="primary" touchless @change="updateRoute">
        <v-tab :key="0" ripple>{{ $t('Conversation') }}</v-tab>
        <!-- <v-tab v-if="isGpt" :key="1" ripple>GPT</v-tab> -->
        <v-tab-item :key="0">
          <intent ref="component-intents" :show-default="true" @getIntent="getIntent">
            <template slot="header">
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <h3 class="headline">{{ $t('Conversation') }}</h3>
                </v-flex>
                <v-flex xs12 sm6 class="text-xs-left text-sm-right">
                  <v-btn depressed color="primary" outline @click="showIntentTemplate = true">
                    {{ $t('conversation_template') }}
                  </v-btn>
                  <transfer-intent
                    type="conversation"
                    :intents="intents"
                    :intent-count="intentCount"
                  ></transfer-intent>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm8>
                  <p style="display: inline-block">
                    {{ $t('To let your Chatbot being more accurate, add more conversation') }}
                  </p>
                </v-flex>
                <v-flex xs12 sm4 class="text-xs-left text-sm-right px-2 pb-3">
                  <a
                    target="_blank"
                    href="https://blog.zwiz.ai/%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B8%B5%E0%B9%84%E0%B8%AB%E0%B8%99%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%97%E0%B8%B3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%AD%E0%B8%97/"
                  >
                    <strong>*** {{ $t('Why my bot is not answer?') }}</strong>
                  </a>
                </v-flex>
              </v-layout>
            </template>
          </intent>
          <IntentTemplateList v-model="showIntentTemplate" @createdIntent="createdTemplateIntent" />
        </v-tab-item>
        <v-tab-item :key="1">
          <GptConversation v-if="advancedTab === 1" />
        </v-tab-item>
      </v-tabs>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Intent from './Intent'
import TransferIntent from './TransferIntent'
import IntentTemplateList from './IntentTemplate/IntentTemplateList'
import GptConversation from './gpt/GptConversation'
import { FEATURE } from '@/constants/feature.js'

export default {
  components: {
    Intent,
    TransferIntent,
    IntentTemplateList,
    GptConversation
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from.name
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  },
  data() {
    return {
      from: '',
      intents: [],
      intentCount: 0,
      showIntentTemplate: false,
      advancedTab: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    dialog() {
      // return this.from == 'Setup'
      return false
    },
    tabType() {
      return {
        0: 'conversation',
        1: 'gpt'
      }[this.advancedTab]
    },
    isGpt() {
      return (
        !!this.selectedBot.features &&
        [...this.selectedBot.features.split(',')].includes(FEATURE.GPT)
      )
    }
  },
  created() {
    this.advancedTab = {
      conversation: 0,
      gpt: 1
    }[this.$route.query.tab]

    this.$store.dispatch('userState/fetch')
  },
  methods: {
    createdTemplateIntent() {
      this.$refs['component-intents'].getIntent()
    },
    getIntent(payload) {
      // this.intents = payload
    },
    handleSetCountIntent(payload) {
      this.intentCount = payload
    },
    joinGroup() {
      window.open('https://www.facebook.com/groups/zwizaigroup/', '_blank')
      this.from = ''
    },
    updateRoute() {
      this.$router.push({
        name: 'conversation',
        path: '/conversation',
        query: {
          tab: this.tabType
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Conversation.vue